import { render, staticRenderFns } from "./bcount.vue?vue&type=template&id=098327de"
import script from "./bcount.vue?vue&type=script&lang=js"
export * from "./bcount.vue?vue&type=script&lang=js"
import style0 from "./bcount.vue?vue&type=style&index=0&id=098327de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports